import React from "react";
import { graphql } from "gatsby";
import { Grid } from "semantic-ui-react";
import Helmet from "react-helmet";
import Markdown from "markdown-to-jsx";
import {
  PageLayout,
  CardNavigation,
  HeroElement,
  About,
  ContactForm,
} from "@fishrmn/fishrmn-components";

// import emailCallback from "../utils/plant-donations-email";

import Layout from "../components/Layout";
import { getPageHeroImages } from "../utils/images";

export default class extends React.PureComponent {
  render() {
    const data = this.props.data.allFisherman.edges[0].node;
    const pageData = this.props.data.fishermanWebsitePage;
    const pageComponents = (pageData && pageData.components) || [];

    return (
      <Layout>
        <Helmet>
          <title>{data.businessName} | Plant Donations</title>
          <meta name="description" content={""} />
        </Helmet>
        <PageLayout
          hero={
            <HeroElement
              header={"Plant Donations"}
              tagline={""}
              images={getPageHeroImages(pageComponents)}
              showMap={false}
              ctas={[]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={500}
              gutter={false}
            />
          }
        >
          <Grid
            stackable
            className="component-section-container rm-padding-bottom"
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={12}>
              <About
                content={
                  <div>
                    Do you have plants that for one reason or another you don’t
                    want? Donate plants to Ophelia's Blue Vine!
                  </div>
                }
                header={""}
                centerContent={true}
                headerAs={null}
                withContainer={true}
              />
            </Grid.Column>
          </Grid>

          <Grid
            stackable
            className="component-section-container"
            verticalAlign={"middle"}
            textAlign={"left"}
          >
            <Grid.Column width={16}>
              <ContactForm
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={false}
                header={"Contact Us"}
                inline={false}
                // onSubmit={emailCallback}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
                businessId={"3488"}
                businessType="restaurant"
                locationId={
                  data.locations.filter(
                    (location) => location.primaryLocation === true
                  )[0].id
                }
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    allFisherman {
      edges {
        node {
          businessName
          aboutMarkdown
          phone
          email
          id
          locations {
            primaryLocation
            id
            address {
              city
              state
              street
              zip
            }
            phoneNumber
          }
          address {
            street
            city
            state
            zip
          }
        }
      }
    }
    fishermanWebsitePage(title: { eq: "Plant Donations" }) {
      description
      components {
        fastId
        order
        files {
          file
        }
      }
    }
  }
`;
